export const ENCRYPTION_LOCK_STORAGE_KEY = "turbonotes2-encryption-lock-minutes";
export const ENCRYPTION_BLUR_LOCK_STORAGE_KEY = "turbonotes2-encryption-lock-on-blur";

/** Minutes without typing or clicking before unlocked folders lock again. */
export const LOCK_MINUTES = [1, 5, 10, 15, 30, 60, 120] as const;
export type LockMinutes = (typeof LOCK_MINUTES)[number];
export const DEFAULT_LOCK_MINUTES: LockMinutes = 10;

export const isLockMinutes = (value: unknown): value is `${LockMinutes}` =>
  LOCK_MINUTES.some((minutes) => String(minutes) === value);

export function loadLockMinutes(storage: Pick<Storage, "getItem">): LockMinutes {
  const value = storage.getItem(ENCRYPTION_LOCK_STORAGE_KEY);
  return isLockMinutes(value) ? (Number(value) as LockMinutes) : DEFAULT_LOCK_MINUTES;
}

/** Whether folders lock as soon as this tab loses focus. On unless turned off. */
export const loadLockOnBlur = (storage: Pick<Storage, "getItem">): boolean =>
  storage.getItem(ENCRYPTION_BLUR_LOCK_STORAGE_KEY) !== "false";

/** Whether folders unlocked at `lastActivity` should lock at `now`. */
export const lockDue = (lastActivity: number, now: number, minutes: number): boolean =>
  now - lastActivity >= minutes * 60000;
